import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {FolderEntity} from './folder.entity';

@EntityTable('flow', 'bb11784e-4f6a-423a-9973-16112228036a')
export class FlowEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, FolderEntity, true, false, FieldRelationKind.BELONGS_TO, 'folder', 'aliasId', 'folderId')
    public folderId: string;

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.ANY)
    public context: any;

    @Column(FieldTypeKind.ANY)
    public outputSchema: any;

    @Column(FieldTypeKind.ANY)
    public inputSchema: any;

    @Column(FieldTypeKind.ANY)
    public steps: any;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
